import { render, staticRenderFns } from "./bankHolidaysTable.vue?vue&type=template&id=bb46100e"
import script from "./bankHolidaysTable.vue?vue&type=script&lang=js"
export * from "./bankHolidaysTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports